import { cn } from "@/lib/utils";
import { CompositeChoice, FillableChoice } from "@/types/questionnaries";
import { FC } from "react";
import AllRequiredChoiceItem from "./all-required-choice-item";

type AllRequiredChoiceListProps = {
  choice: CompositeChoice;
  level?: number;
  className?: string;
  disabled?: boolean;
};

const AllRequiredChoiceList: FC<AllRequiredChoiceListProps> = ({
  choice,
  level = 0,
  className,
  disabled,
}) => {
  return (
    <ul className={cn("grid gap-4", className)}>
      {choice.choices.map((choice) => (
        <AllRequiredChoiceItem
          key={choice.id}
          choice={choice as FillableChoice}
          level={level}
          disabled={disabled}
        />
      ))}
    </ul>
  );
};

export default AllRequiredChoiceList;
